import React from "react";
import { fmtDate, getLinkedPlatforms, statusLabel, statusTone } from "../../lib/platformStatus";

const TONE = {
  green: { dot: "🟢", cls: "border-emerald-500/40 bg-emerald-900/20 text-emerald-200" },
  yellow: { dot: "🟡", cls: "border-amber-500/40 bg-amber-900/20 text-amber-200" },
  red: { dot: "🔴", cls: "border-red-500/40 bg-red-900/20 text-red-200" },
};

export function chipLabel(row) {
  const tier = row.tier && !row.label.toLowerCase().includes(row.tier.toLowerCase()) ? ` ${row.tier}` : "";
  return `${row.label}${tier}`;
}

/** Compact chips, one per linked external platform. `onSelect(platformKey)` is optional. */
export default function PlatformStatusStrip({ video, onSelect, compact = false }) {
  const rows = getLinkedPlatforms(video);
  if (!rows.length) {
    return compact ? null : <div className="text-xs text-zinc-500">No external platforms linked yet.</div>;
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="platform-status-strip">
      {rows.map((r) => {
        const tone = statusTone(r.status);
        const t = TONE[tone];
        const published = tone === "green";
        const Tag = onSelect ? "button" : "span";
        return (
          <Tag key={r.key} {...(onSelect ? { type: "button", onClick: () => onSelect(r.key) } : {})}
            title={`${r.label}: ${statusLabel(r.status) || "Not published"}${r.posted_date ? ` (${fmtDate(r.posted_date)})` : ""}`}
            data-testid={`platform-chip-${r.key}`}
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${t.cls} ${onSelect ? "hover:brightness-125 cursor-pointer" : ""}`}>
            <span>{chipLabel(r)}</span>
            {r.posted_date && !compact && <span className="opacity-75 font-normal">· {fmtDate(r.posted_date)}</span>}
            <span aria-label={published ? "Published" : tone === "yellow" ? "Scheduled or processing" : "Not published or needs attention"}>
              {published ? (compact ? "✓" : "· ✓ Published") : `· ${t.dot}`}
            </span>
          </Tag>
        );
      })}
    </div>
  );
}
